function getPagedFromUrl(url) {
  const parsed = new URL(url, window.location.origin);
  const prettyMatch = parsed.pathname.match(/\/page\/(\d+)\/?/);
  if (prettyMatch) return parseInt(prettyMatch[1], 10);

  const queryPaged = parsed.searchParams.get('paged') || parsed.searchParams.get('page');
  return queryPaged ? parseInt(queryPaged, 10) : 1;
}

export function initBlogPagination() {
  const wrap = document.getElementById('blog-posts-list');
  if (!wrap) return;

  let isLoading = false;

  const loadPage = (url, pushState) => {
    if (isLoading) return;
    isLoading = true;
    wrap.classList.add('is-loading');

    const paged = getPagedFromUrl(url);

    const formData = new FormData();
    formData.append('action', 'dufeng_blog_pagination');
    formData.append('nonce', serawai_ajax.nonce);
    formData.append('paged', paged);

    fetch(serawai_ajax.url, {
      method: 'POST',
      body: formData,
    })
      .then(res => res.json())
      .then(data => {
        if (!data.success || !data.data.html) return;

        wrap.innerHTML = data.data.html;

        if (pushState) {
          history.pushState({ dufengBlogPaged: paged }, '', url);
        }

        wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(() => {
        // Silently fail, link remains usable for a normal navigation retry
      })
      .finally(() => {
        wrap.classList.remove('is-loading');
        isLoading = false;
      });
  };

  wrap.addEventListener('click', (e) => {
    const link = e.target.closest('.paging-navigation a');
    if (!link) return;

    e.preventDefault();
    loadPage(link.href, true);
  });

  window.addEventListener('popstate', () => {
    loadPage(window.location.href, false);
  });
}
